import { Button, Typography } from '@pwskills/rachnaui';
import { Home } from '@pwskills/rachnaui/Icons';
import { useRouter } from 'next/router';
import React, { useContext } from 'react';
import { CategoryColors } from '@/interfaces/leadCapture.enum';
import style from '@/styles/CategoryPage.module.css';
import CategoryStatistics from './CategoryStatistics';
import CategoryPageContext from '../../../context/CategoryPageContext';

const Hero = () => {
  const router = useRouter();
  const { categoryDetails } = useContext(CategoryPageContext);
  const categoryStats = categoryDetails?.metas;
  const handleScrollToHeroSection = (href: string) => {
    const section = document.getElementById(href);
    const sectionTop = Number(section?.offsetTop) - 60;

    window.scrollTo({
      top: sectionTop,
      behavior: 'smooth',
    });
  };

  return (
    <div
      id="category-hero-section"
      className="relative py-8 large:!py-14 large:!gap-[80px] bg-gradient-to-r from-[transparent] via-[#00000080] via-35% to-[#000000] to-80% px-4 medium:!px-8 large:!px-20"
      style={{
        backgroundColor: categoryDetails?.categoryColor
          ? `${categoryDetails?.categoryColor}`
          : CategoryColors.Category_Default_Color,
      }}
    >
      {/* <div className="absolute inse w-full h-[300px] bg-gradient-to-br from-[#ffffffa0] to-transparent "/> */}
      <div className="absolute w-96 h-96 -top-28 -left-28 z-0 rounded-full bg-[#ffffff07] shadow-lg blur-2xl" />
      <div className="absolute inset-0 opacity-[10%]">
        <img
          src="/images/homePageRevamp/noisebg-darkgray.webp"
          alt="Background img"
          className="medium:w-full large:w-full h-full"
        />
      </div>
      <div
        className="absolute w-full h-full inset-0 pointer-events-none z-0"
        style={{
          backgroundImage: `
          linear-gradient(to right, rgba(255,255,255,0.1) 1px, transparent 1px),
          linear-gradient(to top, rgba(255,255,255,0.1) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px',
          opacity: 0.25,
        }}
      />
      <div className="max-w-[1280px] mx-auto relative z-10">
        <div className="relative flex flex-col !gap-[40px] large:!gap-[80px] py-10 z-20">
          <div className="flex items-center gap-1">
            <div className="flex gap-1 justify-center items-center">
              <Home className="w-3 h-3 text-[#D1D1D1]" />
              <Typography
                component="body-small"
                variant="regular"
                className="text-[#D1D1D1] cursor-pointer whitespace-nowrap"
                onClick={() => {
                  router.push('/');
                }}
              >
                Home {`>`}
              </Typography>
            </div>
            <Typography
              component="body-small"
              variant="bold"
              className="text-white whitespace-nowrap overflow-hidden text-ellipsis"
            >
              {categoryDetails?.title}
            </Typography>
          </div>

          {/* <div className="grid medium:grid-cols-2 large:grid-cols-3">
        <div
          style={{
            position: 'relative',
            background: 'linear-gradient(0deg, #FFF7F5 43.43%, #FFF 100%)',
          }}
          className="!h-full large:!h-[520px]"
        >
          <figure style={{ position: 'absolute', top: 0, left: 0 }}>
            <Image src={TopSectionImg} alt="hero img" loading="lazy" />
          </figure>
          <figure style={{ position: 'absolute', bottom: 0, right: 0 }}>
            <Image src={BottomSectionImg} alt="hero img" loading="lazy" />
          </figure>

          <div className="py-[72px] medium:!pt-[156px] medium:!pb-[120px] px-4">
            <div className="flex flex-col gap-4 medium:!gap-6">
              <div className="text-center medium:!text-left">
                <Typography
                  component="h2"
                  variant="bold"
                  className="text-gray-900 text-[24px] medium:!text-[40px] font-inter"
                >
                  {categoryDetails?.title}
                </Typography>
              </div>
              <Typography
                component="body-regular"
                variant="regular"
                className="text-gray-850 text-[14px] !line-clamp-4"
              >
                {categoryDetails?.description}
              </Typography>
            </div>
          </div>
        </div>

        
        <div className="large:mr-5 hidden medium:!block">
          {categoryDetails?.categoryImage?.url && (
            <img
              src={`${categoryDetails?.categoryImage?.url}`}
              className="!w-full !h-full large:!h-[520px] rounded-r-xl"
              alt={`${categoryDetails?.categoryImage?.altText}`}
              loading="lazy"
              width={412}
              height={520}
            />
          )}
        </div>

        
        <div className="hidden large:!block">
          <LeadCapture
            leadCaptureType={LeadCaptureType.FORM}
            buttonText="Get Free Counselling"
            msgLineOne="We Got Your Query."
            msgLineTwo="Our Counsellor will reach out soon"
            type="CategoryPageConnect"
            enquiryType={LeadCaptureEnquiryType.CATEGORY_ENQUIRY}
            enquiryTypeNPF="Category Enquiry"
            modalType={ModalType.CATEGORY_PAGE_FORM}
            pageName="category_page"
          />
        </div>
      </div> */}

          {/* <div className="hidden medium:!block large:mt-10">
        <CategoryStatistics categoryStatistics={categoryStats} />
      </div> */}

          {/* <div className="block large:!hidden">
        <LeadCapture
          leadCaptureType={LeadCaptureType.FORM}
          // modelOpen={openModal}
          // setModelOpen={setOpenModal}
          buttonText="Get Free Counselling"
          msgLineOne="We Got Your Query."
          msgLineTwo="Our Counsellor will reach out soon"
          type="CategoryPageConnect"
          enquiryType={LeadCaptureEnquiryType.CATEGORY_ENQUIRY}
          enquiryTypeNPF="Category Enquiry"
          modalType={ModalType.CATEGORY_PAGE_FORM}
          pageName="category_page"
        />
      </div> */}

          <div className="text-center flex flex-col gap-6 relative">
            <div>
              <div className="relative inline-block w-fit text-center mx-auto">
                <Typography
                  component="h2"
                  variant="bold"
                  className="text-2xl medium:!text-[36px] large:!text-[48px] text-white font-inter medium:!mb-1 !leading-[36px] large:!leading-[60px] w-fit mx-auto"
                >
                  {categoryDetails && categoryDetails?.title.length > 32
                    ? `${categoryDetails?.title.slice(0, 29)}...`
                    : categoryDetails?.title}
                </Typography>

                <img
                  src="/images/homePageRevamp/CatDesign1.svg"
                  alt="design"
                  className="absolute left-0 -translate-x-full top-1/2 -translate-y-1/2 !h-6 large:!h-[38px] medium:!my-[-17px] large:!my-[-25px] !my-[-17px] !w-[22px] large:!w-[35px]"
                />

                <img
                  src="/images/homePageRevamp/CatDesign2.svg"
                  alt="cat-design"
                  className="absolute right-0 translate-x-full top-1/2 -translate-y-1/2 !h-[20px] medium:!h-[26px] large:!h-[39px] my-[-20px] medium:!my-[-20px] large:!my-[-45px] !w-[20px] large:!w-[39px] medium:!w-[26px]"
                />
              </div>

              <img
                src="/images/homePageRevamp/Vector.png"
                alt="design"
                className="text-center mx-auto mt-1 h-[18x] w-fit"
              />
              <div className="mt-1">
                <Typography
                  component="body-regular"
                  variant="regular"
                  className="text-[#D1D1D1] text-[14px] w-fit large:!w-[600px] mx-auto line-clamp-2 break-words"
                >
                  {categoryDetails?.description && categoryDetails?.description.length > 160
                    ? `${categoryDetails?.description.slice(0, 157)}...`
                    : categoryDetails?.description}
                </Typography>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center mx-auto gap-2">
              <Button
                variant="primary"
                size="small"
                className="whitespace-nowrap inline-flex shadow-medium rounded-lg !pl-[18px] pr-4 large:!pr-5 !py-3"
                style={{ backgroundColor: '#E97862' }}
                onClick={() => handleScrollToHeroSection('course-listing-section')}
              >
                <Typography
                  variant="regular"
                  component="body-regular"
                  className="!text-white font-bold !text-[16px]"
                >
                  Explore Now
                </Typography>
                <img
                  src="/images/homePageRevamp/ArrowDown.svg"
                  alt="arrow"
                  className={`w-4 h-4 ${style['arrow-bounce']}`}
                />
              </Button>
            </div>

            <div className="flex mt-4">
              <CategoryStatistics categoryStatistics={categoryStats} />
            </div>
          </div>

          {/* <div className="block medium:!hidden">
        <CategoryStatistics categoryStatistics={categoryStats} />
      </div> */}
        </div>
      </div>
    </div>
  );
};

export default Hero;
